import Vue from "vue";
import themes from '../../themes.json';

const $generateColorVariants = (hex, mode) => {
	// Convert HEX to RGB
	const bigint = parseInt(hex.slice(1), 16);
	const rgb = {
		r: (bigint >> 16) & 255,
		g: (bigint >> 8) & 255,
		b: bigint & 255,
	};

	// same color as default
	let adjustedRGB = {
		r: Math.min(255, Math.max(0, Math.round(rgb.r))),
		g: Math.min(255, Math.max(0, Math.round(rgb.g))),
		b: Math.min(255, Math.max(0, Math.round(rgb.b))),
	}

	if(mode === 'darken'){
		adjustedRGB = {
			r: Math.min(255, Math.max(0, Math.round(rgb.r * 0.8))),
			g: Math.min(255, Math.max(0, Math.round(rgb.g * 0.8))),
			b: Math.min(255, Math.max(0, Math.round(rgb.b * 0.8))),
		}
	}else if(mode === 'lighten'){
		adjustedRGB = {
			r: Math.min(255, Math.max(0, Math.round(rgb.r * 1.2))),
			g: Math.min(255, Math.max(0, Math.round(rgb.g * 1.2))),
			b: Math.min(255, Math.max(0, Math.round(rgb.b * 1.2))),
		}
	}else if(mode === 'pale'){
		adjustedRGB = {
			r: Math.min(255, Math.round((rgb.r + 255) / 2)),
			g: Math.min(255, Math.round((rgb.g + 255) / 2)),
			b: Math.min(255, Math.round((rgb.b + 255) / 2)),
		}
	}

	return `#${((1 << 24) + (adjustedRGB.r << 16) + (adjustedRGB.g << 8) + adjustedRGB.b).toString(16).slice(1)}`
}

const $hexToRGB = (hex) => { // null | rgb string
	const hexPattern = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/;
	if(!hexPattern.test(hex)) return null;

	// Remove the hash character (#) if it exists
	hex = hex.replace(/^#/, '');

	// Parse the hex value to an integer
	const intValue = parseInt(hex, 16);

	// Extract the red, green, and blue components
	const red = (intValue >> 16) & 255;
	const green = (intValue >> 8) & 255;
	const blue = intValue & 255;

	return `${red} ${green} ${blue}`;
}


const $setColor = (name, hex) => {
	const style = document.documentElement.style;
	style.setProperty(`--twc-${name}`, $hexToRGB(hex));
}

// default value for generated dynamic colors
function $setPrimaryColors(primaryColor = '#0d9488'){
	$setColor('primary-darken', $generateColorVariants(primaryColor, 'darken'));
	$setColor('primary', primaryColor);
	$setColor('primary-lighten', $generateColorVariants(primaryColor, 'lighten'));
	$setColor('primary-pale', $generateColorVariants(primaryColor, 'pale'));
}

$setPrimaryColors();
Object.entries(themes.light).forEach(([name, hex]) => {
	$setColor(name, hex);
})

// for use in the App.vue
Vue.prototype.$setPrimaryColors = $setPrimaryColors
Vue.prototype.$setColor = $setColor;
